import { useState, useEffect, useMemo } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import VuiBox from "components/VuiBox";
import Sidenav from "examples/Sidenav";
import theme from "assets/theme";
import buildRoutes from "routes";
import Dashboard from "layouts/dashboard";
import SorguPage from "layouts/sorgu";
import { useVisionUIController, setMiniSidenav } from "context";

export default function App() {
  const [kontrol_merkezi, k_gonderici] = useVisionUIController();
  const menuDaraltildiMi = kontrol_merkezi.miniSidenav;
  const solYanimRengi = kontrol_merkezi.sidenavColor;
  const [ustunde_mouse_var_mi, setUstunde_mouse_var_mi] = useState(false);
  const { pathname } = useLocation();

  const ozel_kullanici = {
    ad: "Telegram Uyesi",
    rol: "Kullanici",
    bayi_mod: false,
    aktif_sorgular: null
  };

  const menuYollari = useMemo(() => buildRoutes(ozel_kullanici), []);

  const fare_gosterme_fonksiyonu = () => {
    if (menuDaraltildiMi && !ustunde_mouse_var_mi) {
      setMiniSidenav(k_gonderici, false);
      setUstunde_mouse_var_mi(true);
    }
  };

  const fare_cekme_islemi = () => {
    if (ustunde_mouse_var_mi) {
      setMiniSidenav(k_gonderici, true);
      setUstunde_mouse_var_mi(false);
    }
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Sidenav
        color={solYanimRengi}
        brandName="SORGU PANELİ"
        routes={menuYollari}
        onMouseEnter={fare_gosterme_fonksiyonu}
        onMouseLeave={fare_cekme_islemi}
      />
      {!menuDaraltildiMi && (
        <div
          onClick={() => setMiniSidenav(k_gonderici, true)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            zIndex: 1099,
            background: "rgba(0,0,0,0.5)",
          }}
        />
      )}
      <Switch>
        <Route exact path="/dashboard">
          <Dashboard kullanici={ozel_kullanici} />
        </Route>
        <Route path="/sorgu/:tip">
          <SorguPage kullanici={ozel_kullanici} />
        </Route>
        <Redirect from="*" to="/dashboard" />
      </Switch>
    </ThemeProvider>
  );
}
